import axios from 'axios';

import { decodeTokenValidate, getClientId } from 'utils/methods';

import { API_REST_URL, DIAGNOSES_URL } from 'config/variables';

import { Client } from 'types/enums';

export const axiosV2 = axios.create();

axiosV2.interceptors.request.use(async config => {
  config.baseURL = API_REST_URL;
  const token = await decodeTokenValidate();
  const subdomain = getClientId(Client.TEAM);
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
    config.headers['client'] = subdomain;
  }
  return config;
});

export const axiosDiagnoses = axios.create();

axiosDiagnoses.interceptors.request.use(async config => {
  config.baseURL = DIAGNOSES_URL;
  const token = await decodeTokenValidate();
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

export default axiosV2;
